module.exports = __webpack_public_path__ + "img/noshop_1.0c7fdf0f.png";